// isCurrentCrew is hand-computed here to mirror what admin_service's SQL window function
// (PARTITION BY roleAlias, COALESCE(vehicleEmail, operatorEmail, appUser email) ORDER BY lastEventDate DESC)
// would actually return - only the most-recently-active operator per (role, shared vehicle inbox) wins.
export const getDeactivatedOperatorsResp = {
  operators: [
    {
      // vessel-alpha's current Captain - most recent lastEventDate in its (role, vehicle) group
      id: "11111111-1111-4111-8111-111111111111",
      operatorCode: "Signol1",
      user: {
        email: "vlad@SG.io",
      },
      creationDate: 1589216355,
      flights: 25,
      active: true,
      appUserId: "a1111111-1111-4111-8111-111111111111",
      lastEventDate: "2026-07-15T00:00:00.000Z",
      roleAlias: "Captain",
      vehicleEmail: "vessel-alpha@ds.io",
      isCurrentCrew: true,
    },
    {
      // vessel-alpha's current Chief Officer
      id: "22222222-2222-4222-8222-222222222222",
      operatorCode: "Signol2",
      creationDate: 1589216355,
      flights: 14,
      active: true,
      appUserId: null,
      lastEventDate: "2026-06-01T00:00:00.000Z",
      roleAlias: "Chief Officer",
      vehicleEmail: "vessel-alpha@ds.io",
      isCurrentCrew: true,
    },
    {
      // vessel-alpha's previous Captain, superseded by Signol1 - still enrolled, no longer current
      id: "33333333-3333-4333-8333-333333333333",
      operatorCode: "Signol3",
      user: {
        email: "bobby@SG.io",
      },
      creationDate: 1589216355,
      flights: 35,
      active: true,
      appUserId: "a3333333-3333-4333-8333-333333333333",
      lastEventDate: "2026-01-01T00:00:00.000Z",
      roleAlias: "Captain",
      vehicleEmail: "vessel-alpha@ds.io",
      isCurrentCrew: false,
    },
    {
      // Only Engineer seen - trivially current, no shared vehicle inbox to compete in
      id: "44444444-4444-4444-8444-444444444444",
      operatorCode: "Signol4",
      creationDate: 1589216355,
      flights: 20,
      active: true,
      appUserId: null,
      lastEventDate: null,
      roleAlias: "Engineer",
      vehicleEmail: null,
      isCurrentCrew: true,
    },
    {
      // vessel-beta's only Captain seen - trivially current
      id: "55555555-5555-4555-8555-555555555555",
      operatorCode: "Signol5",
      creationDate: 1589216355,
      flights: 29,
      active: true,
      appUserId: "a5555555-5555-4555-8555-555555555555",
      lastEventDate: "2026-07-10T00:00:00.000Z",
      roleAlias: "Captain",
      vehicleEmail: "vessel-beta@ds.io",
      isCurrentCrew: true,
    },
    {
      // vessel-alpha's previous Chief Officer, superseded by Signol2, and deactivated
      id: "66666666-6666-4666-8666-666666666666",
      operatorCode: "Signol6",
      user: {
        email: "dalv@SG.io",
      },
      creationDate: 1589216355,
      flights: 10,
      active: false,
      appUserId: "a6666666-6666-4666-8666-666666666666",
      lastEventDate: "2025-01-01T00:00:00.000Z",
      roleAlias: "Chief Officer",
      vehicleEmail: "vessel-alpha@ds.io",
      isCurrentCrew: false,
    },
  ],
};
